
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
img{
  border-radius:var(--border-radius-rounded-default);
  width:100%;
  max-width:100%;
  height:auto;
}

picture{
  width:100%;
  max-width:48%;
}

div[cloned-slot-name='images']{
  display:flex;
  flex-direction:column;
  row-gap:var(--spacing-8);
}

@media (min-width: 480px){

div[cloned-slot-name='images']{
    display:grid;
    grid-template-columns:repeat(4, 1fr);
    grid-row-gap:var(--spacing-8);
    grid-column-gap:var(--spacing-8)
}

    div[cloned-slot-name='images'] div{
      grid-column:span 2;
    }

    div[cloned-slot-name='images'] div:nth-last-child(1):nth-child(odd){
      grid-column:2 / span 2;
    }
  }

.single-image div[cloned-slot-name='images']{
  display:block;
}
`;